module.exports = __webpack_public_path__ + "img/33_48.9858abde.png";